import React from 'react';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from './ui/accordion';
import { FAQS } from '../mock';

export default function FAQ() {
  return (
    <section id="faq" className="relative py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-14">
        <div data-reveal>
          <div className="label-mono text-[var(--accent)] mb-6">Common Ground</div>
          <h2 className="font-display text-[clamp(2.4rem,5.5vw,4.4rem)] text-white">
            Fair <span className="font-display-italic text-[#c3cbdb]">questions.</span>
          </h2>
          <p className="mt-8 text-[var(--muted)] text-[15px] leading-relaxed max-w-sm">
            Anything not answered? Ring the callout desk — same number, same engineer, day or night.
          </p>
        </div>

        <div data-reveal data-delay="90">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[var(--line)]">
                <AccordionTrigger className="py-7 hover:no-underline group">
                  <span className="flex items-center gap-6 text-left">
                    <span className="label-mono text-[var(--accent)]">{String(i + 1).padStart(2, '0')}</span>
                    <span className="font-display text-[clamp(1.1rem,2.2vw,1.5rem)] text-white group-hover:text-[var(--accent)] transition-colors">{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pl-[3.6rem] text-[15px] text-[var(--muted)] leading-relaxed max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
